module.exports = __webpack_public_path__ + "img/bitlabImg4x.9845eef3.png";